import Vue from "vue";

const cuilGen = function(numeroDocumento, sexo) {
  /**
   * Cuil format is: AB - document_number - C
   * Author: Nahuel Sanchez, Woile
   *
   * @param {str} document_number -> string solo digitos
   * @param {str} gender -> debe contener HOMBRE, MUJER o SOCIEDAD
   *
   * @return {str}
   **/
  let HOMBRE = ["HOMBRE", "M", "MALE"];
  let MUJER = ["MUJER", "F", "FEMALE"];
  let SOCIEDAD = ["SOCIEDAD", "S", "SOCIETY"];
  var AB, C;

  /**
   * Verifico que el document_number tenga exactamente ocho numeros y que
   * la cadena no contenga letras.
   */
  if (numeroDocumento.length !== 8 || isNaN(numeroDocumento)) {
    if (numeroDocumento.length === 7 && !isNaN(numeroDocumento)) {
      numeroDocumento = "0".concat(numeroDocumento);
    } else {
      // Muestro un error en caso de no serlo.
      Vue.$log.error("El numero de documento ingresado no es correcto.");
      return "";
    }
  }

  /**
   * De esta manera permitimos que el gender venga en minusculas,
   * mayusculas y titulo.
   */
  sexo = sexo.toUpperCase();

  // Defino el valor del prefijo.
  if (HOMBRE.indexOf(sexo) >= 0) {
    AB = "20";
  } else if (MUJER.indexOf(sexo) >= 0) {
    AB = "27";
  } else {
    AB = "30";
  }

  /*
   * Los numeros (excepto los dos primeros) que le tengo que
   * multiplicar a la cadena formada por el prefijo y por el
   * numero de document_number los tengo almacenados en un arreglo.
   */
  let multiplicadores = [3, 2, 7, 6, 5, 4, 3, 2];

  // Realizo las dos primeras multiplicaciones por separado.
  let calculo = parseInt(AB.charAt(0)) * 5 + parseInt(AB.charAt(1)) * 4;

  /*
   * Recorro el arreglo y el numero de document_number para
   * realizar las multiplicaciones.
   */
  for (let i = 0; i < 8; i++) {
    calculo += parseInt(numeroDocumento.charAt(i)) * multiplicadores[i];
  }

  // Calculo el resto.
  let resto = parseInt(calculo) % 11;

  /*
   * Llevo a cabo la evaluacion de las tres condiciones para
   * determinar el valor de C y conocer el valor definitivo de
   * AB.
   */
  if (SOCIEDAD.indexOf(sexo) < 0 && resto === 1) {
    if (HOMBRE.indexOf(sexo) >= 0) {
      C = "9";
    } else {
      C = "4";
    }
    AB = "23";
  } else if (resto === 0) {
    C = "0";
  } else {
    C = 11 - resto;
  }

  // Generate cuit
  return [AB, numeroDocumento, C].join("");
};

const replaceAll = function(str, search, replacement) {
  return str.split(search).join(replacement);
};

const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  let results = new RegExp(
    "[?&]" + name.replace(/[[\]]/g, "\\$&") + "(=([^&#]*)|&|#|$)"
  ).exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

const getParameterByNameIgnoringNull = (name, url, lowerCase = false) => {
  if (!url) url = window.location.href;
  let paramValue = getParameterByName(name, url);
  if (lowerCase && paramValue != null) {
    paramValue = paramValue.toLowerCase();
  }
  if (
    paramValue === "null" ||
    paramValue === "-1" ||
    (paramValue != null && !paramValue.trim())
  )
    paramValue = null;
  return paramValue;
};

const getTrackingCodeLocal = name => {
  let tc = getParameterByName(name, window.location.href);

  if (tc != null && tc !== "") {
    return tc;
  }
  return null;
};

const obtenerTrackingCode = function() {
  let keys = ["cid", "onsite", "ema", "psm", "dis", "afi", "afl"];
  let tc = "";

  for (let ndx = 0; ndx < keys.length; ndx++) {
    let key = keys[ndx];
    let tccan = getTrackingCodeLocal(key);
    if (tccan !== null) {
      tc = tccan;
      break;
    }
  }

  if (tc === "") {
    return "";
  }

  let tcSplit = "";
  let tcBuild = "";

  if (tc.indexOf(":") === -1) {
    // Tracking codes viejos
    tcSplit = tc.split("-");
  } else {
    // Tracking codes nuevos
    replaceAll(tc, "_", " ");
    tcSplit = tc.split("-")[0].split(":");
  }

  tcBuild =
    tcSplit[0].trim() +
    "-" +
    tcSplit[1].trim() +
    "-" +
    tcSplit[2].trim() +
    "-" +
    tcSplit[3].trim();

  return "-" + tcBuild;
};

const toTitleCase = function(str) {
  if (!!str && str.trim() !== "") {
    return str.replace(
      /\w\S*/g,
      txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
  }
  return str;
};

const isDev = function() {
  return !PRODUCTION;
};

const isValidDate = function(dateString) {
  // Verificar patrón
  var regex_date = /\d{2}\/\d{2}\/\d{4}/;

  if (!regex_date.test(dateString)) {
    return false;
  }

  // Parsear string de fecha
  var parts = dateString.split("/");
  var day = parseInt(parts[0], 10);
  var month = parseInt(parts[1], 10);
  var year = parseInt(parts[2], 10);

  // Rango de meses y años
  if (year < 1000 || year > 3000 || month == 0 || month > 12) {
    return false;
  }

  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Ajustar años biciestos
  if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
    monthLength[1] = 29;
  }

  // Verificar rango de días
  return day > 0 && day <= monthLength[month - 1];
};

export {
  cuilGen,
  isValidDate,
  getParameterByName,
  getParameterByNameIgnoringNull,
  getTrackingCodeLocal,
  obtenerTrackingCode,
  replaceAll,
  toTitleCase,
  isDev
};
